import { Col, Form, FormInstance, Input, InputNumber, Row } from 'antd';
import { useTranslation } from 'react-i18next';

import { AddressInput } from '@/components/shared';

export type FormLocation = {
  id?: string;
  name: string;
  street: string;
  zip: string;
  city: string;
  state: string;
  country: string;
  radius: number;
};

type LocationFormProps = {
  form: FormInstance<FormLocation>;
  location?: FormLocation;
  onFinish: (location: FormLocation) => void;
  isEditingMode: boolean;
};

export const LocationForm = ({ form, location, onFinish, isEditingMode }: LocationFormProps) => {
  const { t } = useTranslation('forms');

  return (
    <Form
      form={form}
      initialValues={location}
      layout='vertical'
      disabled={!isEditingMode}
      onFinish={onFinish}
    >
      <Form.Item name='id' hidden>
        <Input />
      </Form.Item>
      <Form.Item label={t('name')} name='name' rules={[{ required: true }]}>
        <Input placeholder={t('forms:locationNamePlaceholder')} />
      </Form.Item>
      <Form.Item label={t('street')} name='street' rules={[{ required: true }]}>
        <AddressInput
          placeholder={t('street')}
          value={location?.street}
          onChange={(value) => {
            form.setFieldsValue({ street: value });
          }}
          onSelect={(label, value) => {
            form.setFieldsValue({
              street: `${value.street ?? ''} ${value.houseNumber ?? ''}`.trim(),
              zip: value.postalCode,
              city: value.city,
              state: value.state,
              country: value.countryName,
            });
          }}
        />
      </Form.Item>
      <Row gutter={[12, 12]}>
        <Col xs={24} md={8}>
          <Form.Item label={t('zip')} name='zip' rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} md={16}>
          <Form.Item label={t('city')} name='city' rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[12, 12]}>
        <Col xs={24} md={12}>
          <Form.Item label={t('state')} name='state' rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item label={t('country')} name='country' rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item
        label={t('forms:radius')}
        name='radius'
        rules={[{ required: true }]}
        extra={t('forms:radiusHint')}
      >
        <InputNumber<number>
          min={1}
          max={100}
          style={{ width: '100%' }}
          disabled={!isEditingMode}
          suffix='km'
        />
      </Form.Item>
    </Form>
  );
};
